export const CURRENCY_BY_COUNTRY = {
  albania: 'ALL',
  'united arab emirates': 'AED',
  anguilla: 'XCD',
  argentina: 'ARS',
  armenia: 'AMD',
  aruba: 'AWG',
  australia: 'AUD',
  austria: 'EUR',
  azerbaijan: 'AZN',
  belgium: 'EUR',
  bangladesh: 'BDT',
  bulgaria: 'EUR',
  bahrain: 'BHD',
  bahamas: 'BSD',
  'bosnia and herzegovina': 'BAM',
  belarus: 'BYN',
  belize: 'BZD',
  bermuda: 'BMD',
  'bolivia, plurinational state of': 'BOB',
  bolivia: 'BOB',
  brazil: 'BRL',
  barbados: 'BBD',
  'brunei darussalam': 'BND',
  botswana: 'BWP',
  canada: 'CAD',
  'cape verde': 'CVE',
  switzerland: 'CHF',
  'central african republic': 'XAF',
  'west african republic': 'XOF',
  chile: 'CLP',
  china: 'CNY',
  colombia: 'COP',
  comoros: 'KMF',
  'cabo verde': 'CVE',
  'costa rica': 'CRC',
  cuba: 'CUP',
  'cayman islands': 'KYD',
  cyprus: 'EUR',
  czechia: 'EUR',
  'czech republic': 'EUR',
  germany: 'EUR',
  djibouti: 'DJF',
  denmark: 'EUR',
  'dominican republic': 'DOP',
  algeria: 'DZD',
  ecuador: 'USD',
  egypt: 'EGP',
  spain: 'EUR',
  estonia: 'EUR',
  ethiopia: 'ETB',
  'falkland islands': 'FKP',
  finland: 'EUR',
  fiji: 'FJD',
  france: 'EUR',
  gabon: 'GMD',
  gambia: 'GMD',
  'united kingdom': 'GBP',
  georgia: 'GEL',
  ghana: 'GHS',
  gibraltar: 'GIP',
  greece: 'EUR',
  guatemala: 'GTQ',
  guam: 'GUF',
  guernsey: 'GGP',
  guinea: 'GNF',
  guyana: 'GYD',
  'hong kong': 'HKD',
  honduras: 'HNL',
  croatia: 'EUR',
  hungary: 'EUR',
  indonesia: 'IDR',
  india: 'INR',
  ireland: 'EUR',
  iceland: 'ISK',
  'isle of man': 'IMP',
  israel: 'ILS',
  italy: 'EUR',
  jamaica: 'JMD',
  jersey: 'JEP',
  jordan: 'JOD',
  japan: 'JPY',
  kazakhstan: 'KZT',
  kenya: 'KES',
  kuwait: 'KWD',
  kyrgyzstan: 'KGS',
  cambodia: 'KHR',
  'korea, republic of': 'KRW',
  "lao people's democratic republic": 'LAK',
  laos: 'LAK',
  lebanon: 'LBP',
  liberia: 'LRD',
  libya: 'LYD',
  'sri lanka': 'LKR',
  lithuania: 'EUR',
  luxembourg: 'EUR',
  latvia: 'EUR',
  mauritania: 'MRO',
  mauritius: 'MUR',
  morocco: 'MAD',
  'moldova, republic of': 'MDL',
  moldova: 'MDL',
  maldives: 'MVR',
  mexico: 'MXN',
  'north macedonia': 'MKD',
  macedonia: 'MKD',
  malta: 'EUR',
  mozambique: 'MZN',
  malawi: 'MWK',
  malaysia: 'MYR',
  mongolia: 'MNT',
  namibia: 'NAD',
  nepal: 'NPR',
  nigeria: 'NGN',
  nicaragua: 'NIO',
  netherlands: 'EUR',
  norway: 'NOK',
  'new zealand': 'NZD',
  oman: 'OMR',
  pakistan: 'PKR',
  panama: 'PAB',
  peru: 'PEN',
  philippines: 'PHP',
  'papua new guinea': 'PGK',
  poland: 'PLN',
  portugal: 'EUR',
  paraguay: 'PYG',
  qatar: 'QAR',
  romania: 'EUR',
  russia: 'RUB',
  'russian federation': 'RUB',
  rwanda: 'RWF',
  'saint helena': 'SHP',
  singapore: 'SGD',
  'solomon islands': 'SBD',
  'sierra leone': 'SLL',
  'el salvador': 'SVC',
  somalia: 'SOS',
  serbia: 'RSD',
  'sao tome and principe': 'STD',
  suriname: 'SRD',
  slovakia: 'EUR',
  slovenia: 'EUR',
  sweden: 'EUR',
  seychelles: 'SCR',
  'syrian arab republic': 'SYP',
  syria: 'SYP',
  swaziland: 'SZL',
  thailand: 'THB',
  tonga: 'TOP',
  'trinidad and tobago': 'TTD',
  tunisia: 'TND',
  turkey: 'TRY',
  tuvalu: 'TVD',
  'taiwan, province of china': 'TWD',
  taiwan: 'TWD',
  'tanzania, united republic of': 'TZS',
  tanzania: 'TZS',
  uganda: 'UGX',
  ukraine: 'UAH',
  uruguay: 'UYU',
  'united states': 'USD',
  uzbekistan: 'UZS',
  vanuatu: 'VUV',
  'venezuela, bolivarian republic of': 'VEF',
  venezuela: 'VEF',
  vietnam: 'VND',
  samoa: 'WST',
  yemen: 'YER',
  'south africa': 'ZAR',
  zambia: 'ZMW',
  'south korea': 'KRW',
  macao: 'MOP',
  'saudi arabia': 'SAR',
}

export type CurrencyByCountryType = keyof typeof CURRENCY_BY_COUNTRY
